import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { userFinishedTopicThunk } from "../store/thunks";
import logCompletedActivity from "../components/activities/common/logCompletedActivity";
import { selectIsTopicFinished } from "../store/selectors";

export const useActivityLogger = (topic, currentSection, SECTIONS) => {
  const dispatch = useDispatch();
  const isFinished = useSelector((state) =>
    selectIsTopicFinished(state, topic.contentKey)
  );
  const finishedTopics = useSelector((state) => state.progress.finishedTopics);
  const allTopics = useSelector((state) => Object.values(state.topics));
  const pmApproach = useSelector((state) => state.progress.section);

  useEffect(() => {
    if (currentSection === SECTIONS.final && !isFinished) {
      dispatch(
        userFinishedTopicThunk([...finishedTopics, topic.contentKey])
      ).then((finishedTopics) => {
        logCompletedActivity(
          topic,
          finishedTopics,
          allTopics,
          pmApproach,
          dispatch
        );
      });
    }
  }, [
    currentSection,
    dispatch,
    SECTIONS,
    isFinished,
    topic,
    finishedTopics,
    allTopics,
  ]);
};
